import { render, staticRenderFns } from "./AdminPromosAdd.vue?vue&type=template&id=0299f8a2&"
import script from "./AdminPromosAdd.vue?vue&type=script&lang=js&"
export * from "./AdminPromosAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports